const burger = document.querySelector('[data-behaviour="burger"]');
const mobileNav = document.querySelector('[data-behaviour="mobile-nav"]');
const body = document.body;
console.log(burger);
if (burger) {
    const closedClass = 'closed';
    const openClass = 'open';
    const searchCloseClass = 'closed';
    const searchOpenClass = 'open';

    burger.addEventListener('click', (e) => {
        e.preventDefault();
        body.classList.toggle('locked');
        const svg = burger.querySelector('svg');

        svg.classList.toggle('active');
        mobileNav.classList.toggle(openClass);
        mobileNav.classList.toggle(closedClass);
    });
}

// Mobile submenu toggle functionality
document.addEventListener('DOMContentLoaded', () => {
    const submenuToggles = document.querySelectorAll(
        '[data-behaviour="mobile-submenu-toggle"]',
    );

    console.log('Submenu toggles found:', submenuToggles.length);

    submenuToggles.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            console.log('Chevron clicked');

            const parentItem = toggle.closest(
                '.site-header__mobile-nav-list-item',
            );
            const submenu = parentItem.querySelector(
                '.site-header__mobile-child-menu',
            );
            const chevron = toggle.querySelector('svg');

            console.log('Submenu found:', submenu);

            if (submenu) {
                submenu.classList.toggle('open');
                chevron.classList.toggle('rotated');
                console.log(
                    'Toggled open class, submenu classes:',
                    submenu.classList,
                );
            }
        });
    });
});
